import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CrewPage } from '@/features/workforce/crew-page';

const searchSchema = z.object({
  engage: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/workforce/crew/')({
  validateSearch: searchSchema,
  component: CrewRoute,
});

function CrewRoute() {
  const { projectId } = Route.useParams();
  const { engage } = Route.useSearch();
  return <CrewPage projectId={projectId} engage={engage} />;
}
